import dayjs, { Dayjs } from "dayjs";

import { i18n } from "@/i18n";

export type DateType = string | number | Dayjs | Date;

export const dateAsDayjs = (date?: DateType | null): Dayjs => {
  return dayjs(date);
};

export const isFutureDate = (date?: DateType | null): boolean => {
  return dateAsDayjs(date).isAfter(dayjs(), "day");
};

export const formatDateToIso = (date?: DateType | null) => {
  return dateAsDayjs(date).toISOString();
};

export const formatTime = ({
  date,
  format = "h:mm A",
}: {
  date: DateType;
  format?: string;
}) => {
  return dateAsDayjs(date).format(format);
};

export const formatApplicationDate = (date: DateType) => {
  return dateAsDayjs(date).format(
    i18n.t("native:applicationsListScreen.applicationDate"),
  );
};

// Long, human-readable date (e.g. "September 15, 2026")
export const formatLongDate = (date?: DateType) => {
  return dateAsDayjs(date).format(i18n.t("common:longDateFormat"));
};

export const parseDateStringToYearMonthDay = (dateString: string) => {
  const [year, month, day] = dateString.split("-");
  return {
    year: year ?? "",
    month: month ?? "",
    day: day ?? "",
  };
};

export const getMonthsUntilDate = (dateStr: string): number => {
  const targetDate = dayjs(dateStr).startOf("day");
  const today = dayjs().startOf("day");
  const diffInMonths = targetDate.diff(today, "month");

  return diffInMonths < 0 ? 0 : diffInMonths;
};

export const getDaysUntilDate = (dateStr: string): number => {
  const targetDate = dayjs(dateStr).startOf("day");
  const today = dayjs().startOf("day");
  const diffInDays = targetDate.diff(today, "day");

  return diffInDays < 0 ? 0 : diffInDays;
};
